import { createFileRoute } from '@tanstack/react-router';
import { CustomersScreen } from '../../../features/customers/customers-screen';

export const Route = createFileRoute('/_authenticated/clienti/')({
  component: CustomersScreen,
});
